var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.979,
    height: 14.06,
    viewBox: "0 0 8.979 14.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26813",
    "data-name": "Group 26813",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26814",
    "data-name": "Group 26814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14203",
    "data-name": "Path 14203",
    d: "M80.448,4.073a2.037,2.037,0,1,0-2.037-2.037,2.037,2.037,0,0,0,2.037,2.037",
    transform: "translate(-75.958)",
    fill: "#0d2768"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14204",
    "data-name": "Path 14204",
    d: "M8.354,88.349a.826.826,0,0,0-.9.453A2.63,2.63,0,0,1,5.225,90.14c-.184.019-.45.031-.735.038s-.552-.019-.735-.038A2.63,2.63,0,0,1,1.522,88.8a.826.826,0,0,0-.9-.453.793.793,0,0,0-.548,1.115,3.593,3.593,0,0,0,2.383,2.052v7.2a.9.9,0,0,0,.7.892.883.883,0,0,0,1.057-.859V94.866H4.76v3.886a.883.883,0,0,0,1.057.859.9.9,0,0,0,.7-.892v-7.2A3.593,3.593,0,0,0,8.9,89.463a.793.793,0,0,0-.548-1.115",
    transform: "translate(0 -85.567)",
    fill: "#0d2768"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKid);
export default __webpack_public_path__ + "static/media/kid.5f9f6658f100fe9bbe1523f79d16d69c.svg";
export { ForwardRef as ReactComponent };